import { useStoreSelector } from 'store/hooks/storeHooks';

export const useFeatureFlag = (flags: string | string[]): any => {
  const { featureFlags } = useStoreSelector((state) => state.featureFlags);

  if (Array.isArray(flags)) {
    return flags.map((flag) => !!featureFlags?.[flag]);
  }

  return !!featureFlags?.[flags];
};
